export default __webpack_public_path__ + "static/media/banner.c30f7354.jpg";